/*
 * Vehicle selector v2 (candidate for theme 197402951840).
 * Data source: assets/jdy-vehicle-map.json (generated by scripts/build_selector_asset.js from real product fitment).
 * Fallback: if the JSON cannot be loaded or fails validation, the legacy .colJson behaviour (Stage 1 logic) is used unchanged.
 * Behaviour: leaf nodes navigate to their collection; GO goes to the deepest selection; Engine change navigates; no empty end points
 * (the generator never emits one).  DOM ids, option markup (data-url) and the PDP localStorage writer are untouched.
 */
(function () {
  var selectArr = ["selectMake", "selectModel", "selectClassis", "selectEngine"];
  var selectMap = { selectMake: 0, selectModel: 1, selectClassis: 2, selectEngine: 3 };
  var selectDefVal = { selectMake: "Make", selectModel: "Model", selectClassis: "Chassis", selectEngine: "Engine" };
  function el(id) { return document.getElementById(id); }
  function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;"); }

  function optionsHtml(label, arr) {
    var html = '<option value="">' + label + "</option>";
    for (var j = 0; j < arr.length; j++) {
      html += '<option value="' + esc(arr[j].id) + '" data-url="' + esc(arr[j].url) + '">' + esc(arr[j].title) + "</option>";
    }
    return html;
  }
  function resetSelect(element) {
    for (var s = selectMap[element] + 1; s < 4; s++) {
      var t = el(selectArr[s]);
      if (t) { t.innerHTML = '<option value="">' + selectDefVal[selectArr[s]] + "</option>"; }
    }
  }
  function navigate(url) {
    if (!url || url === "undefined" || url.charAt(0) !== "/") { return; }
    window.location.href = window.location.origin + url;
  }
  window.jdyFinderTarget = function () {
    for (var s = 3; s >= 0; s--) {
      var sel = el(selectArr[s]);
      if (sel && sel.value) {
        var opt = sel.options[sel.selectedIndex];
        if (opt && opt.dataset.url) { return opt.dataset.url; }
      }
    }
    return "";
  };

  // shared wiring: top = [{id,title,url}], data = { parentId: [children] }
  function wire(top, data, pid) {
    if (pid) {
      var m = el("selectModel");
      if (m) { m.innerHTML = optionsHtml("Model", top); }
    } else {
      var mk = el("selectMake");
      if (mk) { mk.innerHTML = optionsHtml("Make", top); }
    }
    function fillNext(element, arr) {
      var next = selectArr[selectMap[element] + 1];
      el(next).innerHTML = optionsHtml(selectDefVal[next], arr || []);
      resetSelect(next);
    }
    function onPick(selectId) {
      var sel = el(selectId);
      if (!sel) { return; }
      if (sel.value === "") { resetSelect(selectId); return; }
      var kids = data[sel.value];
      if (kids && kids.length > 0) { fillNext(selectId, kids); }
      else { resetSelect(selectId); navigate(sel.options[sel.selectedIndex].dataset.url); }
    }
    ["selectMake", "selectModel", "selectClassis"].forEach(function (id) {
      var n = el(id);
      if (n) { n.addEventListener("change", function () { onPick(id); }); }
    });
    var eng = el("selectEngine");
    if (eng) {
      eng.addEventListener("change", function () {
        if (this.value === "") { return; }
        navigate(this.options[this.selectedIndex].dataset.url);
      });
    }
    var mkSel = el("selectMake");
    if (mkSel) { mkSel.options[0].selected = true; }
    document.documentElement.setAttribute("data-vehicle-selector", "ready");
  }

  // ---- legacy source: hidden .colJson spans (Liquid loop over collections) ----
  function initLegacy(pid) {
    var spans = document.getElementsByClassName("colJson");
    var top = [], data = {};
    for (var i = 0; i < spans.length; i++) {
      var ds = spans[i].dataset;
      var isParent = pid ? ds.parent.indexOf(pid) > 0 : ds.parent == pid;
      var item = { id: ds.id, title: ds.title, url: ds.url, count: ds.count === undefined ? 1 : parseInt(ds.count, 10) || 0 };
      if (isParent) { top.push(item); }
      else {
        var parts = ds.parent.split("/"), key = parts[parts.length - 1];
        (data[key] = data[key] || []).push(item);
      }
    }
    function keep(node, seen) {
      if (seen[node.id]) { return false; }
      seen[node.id] = true;
      var kept = [], kids = data[node.id] || [];
      for (var k = 0; k < kids.length; k++) { if (keep(kids[k], seen)) { kept.push(kids[k]); } }
      data[node.id] = kept; delete seen[node.id];
      return node.count > 0 || kept.length > 0;
    }
    top = top.filter(function (n) { return keep(n, {}); });
    document.documentElement.setAttribute("data-vehicle-source", "legacy");
    wire(top, data, pid);
  }

  // ---- generated source: assets/jdy-vehicle-map.json ----
  function fromMap(map) {
    if (!map || !map.makes || !map.makes.length) { throw new Error("empty map"); }
    var top = [], data = {}, seq = 0;
    function mk(n) { return { id: "v" + (++seq), title: n.t, url: n.u }; }
    function ok(n) { return n && typeof n.t === "string" && typeof n.u === "string" && n.u.charAt(0) === "/"; }
    map.makes.forEach(function (a) {
      if (!ok(a)) { return; }
      var A = mk(a); top.push(A); data[A.id] = [];
      (a.m || []).forEach(function (b) {
        if (!ok(b)) { return; }
        var B = mk(b); data[A.id].push(B); data[B.id] = [];
        (b.c || []).forEach(function (c) {
          if (!ok(c)) { return; }
          var C = mk(c); data[B.id].push(C); data[C.id] = [];
          (c.e || []).forEach(function (e) { if (ok(e)) { data[C.id].push(mk(e)); } });
        });
      });
    });
    if (!top.length) { throw new Error("no valid makes"); }
    return { top: top, data: data };
  }

  function start() {
    var box = document.getElementsByClassName("select-box");
    if (!box.length || !el("selectModel")) { return; }
    var pid = box[0].dataset.pid ? box[0].dataset.pid : "";
    var src = box[0].dataset.vehicleMap;
    if (pid || !src || !window.fetch) { initLegacy(pid); return; }
    fetch(src, { credentials: "omit" })
      .then(function (r) { if (!r.ok) { throw new Error("http " + r.status); } return r.json(); })
      .then(function (map) {
        var built = fromMap(map);
        document.documentElement.setAttribute("data-vehicle-source", "map");
        wire(built.top, built.data, "");
      })
      .catch(function () { initLegacy(pid); });
  }
  start();
})();
